import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-user-register-dialog',
    templateUrl: './user-register-dialog.component.html',
    styleUrls: ['./user-register-dialog.component.scss']
})
export class UserRegisterDialogComponent {
    registerForm: FormGroup;
    hidePassword = true;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<UserRegisterDialogComponent>
    ) {
        this.registerForm = this.fb.group({
            name: ['', Validators.required],
            // ▼ 変更: user_name -> email
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            authority: ['admin', Validators.required]
        });
    }

    onSubmit(): void {
        if (this.registerForm.invalid) {
            return;
        }

        this.authService.register(this.registerForm.value).subscribe({
            next: () => {
                this.snackBar.open('ユーザーを作成しました', 'Close', { duration: 3000 });
                this.dialogRef.close(true);
            },
            error: (err) => {
                console.error('Registration failed', err);
                const msg = err.error.detail || '登録に失敗しました';
                this.snackBar.open(msg, 'Close', { duration: 3000 });
            }
        });
    }
}